import { createStyles, Theme } from '@material-ui/core';

export const estilos = (tema: Theme) =>
  createStyles({
    contenedorTextField: {
      padding: tema.spacing(2),
    },
  });
